import { defineElement, FC, useElement, useListen } from '@atomify/hooks';
import { GTMPush } from '@source/utilities/gtm';

const HouseCharacteristicsCard: FC = () => {
    const trigger = useElement<HTMLElement>('[js-hook-house-characteristics-card-trigger]');

    useListen(trigger, 'click', onOpenModal);

    function onOpenModal() {
        const currentPath = window.location.pathname;

        GTMPush({
            event: 'gtm.virtualPageview',
            virtualurl: `${currentPath}/toon-alle-kenmerken`,
            virtualtitle: 'Toon Alle Kenmerken',
        });
    }
};

defineElement('house-characteristics-card', HouseCharacteristicsCard);
